import { useApi } from '@hooks/useApi';
import { Acquirer, ApiError } from '@root/globalTypes';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { queryKeys } from '@utils/consts';

export type UserResponse = Acquirer | ApiError;

export function isFailure(data: UserResponse): data is ApiError {
  return (data as ApiError)?.message !== undefined;
}

type CreateUserParams = {
  callback: (data: Acquirer) => void;
};

export function useCreateAcquirer({ callback }: CreateUserParams) {
  const { query } = useApi();
  const queryClient = useQueryClient();
  const [apiError, setApiError] = useState<ApiError | null>(null);

  const { mutate, isPending } = useMutation({
    mutationFn: (acquirerData: FormData): Promise<Acquirer> => {
      return query({
        path: 'v1/staff/acquirers',
        formData: true,
        opt: {
          method: 'POST',
          body: acquirerData,
        },
      });
    },
    onSettled: (data) => {
      if (!data) return;
      if (isFailure(data)) {
        setApiError(data);
      } else {
        callback(data);
      }
    },
    onSuccess: async () => {
      await queryClient.refetchQueries({ queryKey: queryKeys.staffAcquirers });
    },
  });

  return {
    mutate,
    isPending,
    error: apiError,
  };
}
